export default __webpack_public_path__ + "static/media/profileCardExp.c110b230.svg";